import config from "environment";
import { getRequest, postRequest } from "./client";
import { DashboardThemeResponse, AIResponseSave } from "winslow-core";
import {
  apiDashboardGetCategoryResponsesForCollectionPayload,
  apiDashboardGetThemeResponsesForCollectionPayload,
} from "./DashboardService.types";

const { baseApi } = config;

// export async function apiDashboardGetCategoryResponsesForCollection(
//     collectionId: string
//   ): Promise<AIResponseSave[] | null> {
//     const fetchURL = `${baseApi}/ai/saved-responses-for-user-in-collection/${userId}/${collectionId}`;
//     return await getRequest(
//       fetchURL,
//       "API/apiAIGetResponseSavesForUserInCollection"
//     );
//   }

export async function apiDashboardGetCategoryResponsesForCollection(
  collectionId: string,
  payload: apiDashboardGetCategoryResponsesForCollectionPayload
): Promise<AIResponseSave[] | null> {
  const fetchURL = `${baseApi}/dashboard/summary/${collectionId}`;
  console.log(
    "[apiDashboardGetCategoryResponsesForCollection] payload: ",
    payload
  );
  return await postRequest(
    fetchURL,
    payload,
    "API/apiDashboardGetCategoryResponsesForCollection"
  );
}

export async function apiDashboardGetThemeResponsesForCollection(
  payload: apiDashboardGetThemeResponsesForCollectionPayload
): Promise<DashboardThemeResponse[] | null> {
  const fetchURL = `${baseApi}/dashboard/theme`;
  console.log(
    "[apiDashboardGetThemeResponsesForCollection] payload: ",
    payload
  );
  return await postRequest(
    fetchURL,
    payload,
    "API/apiDashboardGetThemeResponsesForCollection"
  );
}
